import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { setMenuSelected_2 } from '@redux/actions/menuAction';
import PropTypes from 'prop-types';

import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import { getList, exportData } from 'api/inspectionApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import { createForm } from 'rc-form';
import PageLockHOC from 'hoc/pageLock';
import Clearfix from 'components/elements/clearfix';
import { Col, Row } from 'reactstrap';
import YearSelect from 'components/elements/select-year';
import { get as _get } from 'lodash'
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityInspection.view'])
class InspectionList extends BaseListContainer {
  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'InspectionNumber',
        text: 'Số quyết định đoàn thanh tra',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={`${slug.INSPECTTION.VIEW_WITH_ID}${row._id ? row._id : ''}`}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      {
        dataField: 'facilities',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          if (cell && cell.length) {
            const data = _.sortBy(cell, ['FacilityNameFull'])
            return data.map((item, index) => {
              return (
                <Link
                  key={index}
                  target='_blank'
                  to={`${slug.CO_SO.VIEW_WITH_ID}${item._id ? item._id : ''}`}
                  onClick={() => this.props.setMenuSelected_2(null)}
                >
                  <NameContainer>{item.FacilityNameFull}</NameContainer>
                </Link>
              );
            });
          } else return '';
        },
      },
      {
        dataField: 'DecideDate',
        text: 'Ngày ra quyết định',
        formatter: (cell, row) => {
          if (!cell) {
            return '';
          }
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'AddedOn',
        text: 'Thêm vào',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'UpdatedOn',
        text: 'Cập nhật ngày',
        formatter: (cell, row) => {
          if (!cell) {
            return null;
          }
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      slug.INSPECTTION.CREATE,
      'facilityInspection'
    );
    this.state = {
      ...this.state,
    };
  }

  static propTypes = {
    setMenuSelected_2: PropTypes.func,
  };

  renderSearchContainer() {
    return <div>{super.renderSearchContainer()}</div>;
  }

  renderSearchExpandContainer = () => {
    const { form } = this.props;
    return (
      <div>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <YearSelect
              label={'Năm ra quyết định'}
              fieldForm={{
                form: form,
                name: 'DecideDate',
              }}
            />
          </Col>

        </Row>
      </div>
    );
  };

  handelSubmitSearch(values) {
    values.DecideDate = _get(values.DecideDate, 'value');
    super.handelSubmitSearch(values);
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected_2,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(InspectionList))
);



// WEBPACK FOOTER //
// ./src/containers/Inspection/InspectionList/index.js